<template>
  <div class="module-layer1">
    <video
      loop
      muted
      autoplay
      class="video-bg2 video-size"
      id="bgVideo"
      ref="bgVideo"
      v-if="videoFlag"
      x5-video-player-type="h5"
      playsinline="true"
      webkit-playsinline="true"
    >
      <source
        src="https://resource-mp4.ujoygames.com/cof/bg_s.mp4"
        type="video/mp4"
      />
    </video>
    <div class="kv-content">
      <div class="kv-play-btn" @click="showVideo"></div>
      <div class="kv-slogan"></div>
      <!-- <div class="kv-reg-btn" @click="reg_page"></div> -->
      <div class="kv-channel-list">
        <img
          src="../../assets/img/layer1/gp.png"
          alt=""
          srcset=""
          @click="GP_click('gp')"
        />
        <img
          src="../../assets/img/layer1/ap.png"
          alt=""
          srcset=""
          @click="AS_click('ios')"
        />
        <img
          src="../../assets/img/layer1/os.png"
          alt=""
          srcset=""
          @click="OS_click('os')"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      videoFlag: false
    };
  },
  watch: {},
  created() {
    setTimeout(() => {
      this.videoFlag = true;
    }, 500);
  },
  methods: {
    OS_click(val) {
      this.common.goShare(val);
    },
    AS_click(val) {
      this.common.goShare(val);
    },
    GP_click(val) {
      this.common.goShare(val);
    },

    showVideo() {
      this.$emit("handleVideo");
    },
    // reg_page() {
    //   gtag("event", "reg_page");

    //   this.$emit("handleReg");
    // }
  }
};
</script>
<style lang="scss">
.module-layer1 {
  width: 100%;
  height: 100%;
  background: url("../../assets/img/layer1/bg.png") 50% no-repeat;
  background-size: cover;

  .video-size {
    position: absolute;
    left: 50%;
    top: 50%;
    /*保证视频内容始终居中*/
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    /*保证视频充满屏幕*/
    object-fit: cover;
    pointer-events: none;
    display: block;
  }

  .kv-content {
    position: absolute;
    bottom:30vw;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .kv-play-btn {
      width: 170px;
      height: 170px;
      background: url("../../assets/img/layer1/play-btn.png") 50% no-repeat;
      background-size: cover;
      margin-bottom:2vw;
    }

    .kv-slogan {
      width: 450px;
      height: 255px;
      background: url("../../assets/img/layer1/slogan.png") 50% no-repeat;
      background-size: cover;
    }

    .kv-reg-btn {
      width: 381px;
      height: 81px;
      background: url("../../assets/img/layer1/regbtn-bg.png") 50% no-repeat;
      background-size: cover;
      margin: 3vw 0;
    }

    .kv-channel-list {
      display: flex;
      align-items: center;
      gap: 16px;

      img {
        width: 222px;
        height: 66px;
        display: block;
      }
    }
  }
}

@media screen and (min-width: 638px) and (max-width: 1024px) and (orientation: portrait) {
  .module-layer1 {
    .kv-content {
      bottom: 12vw !important;
      .kv-play-btn {
        width: 136px !important;
        height: 136px !important;
      }
      .kv-slogan {
        width: 360px !important;
        height: 204px !important;
      }
      .kv-reg-btn {
        width: 305px !important;
        height: 64px !important;
      }
      .kv-channel-list {
        img {
          width: 178px !important;
          height: 53px !important;
        }
      }
    }
  }
}

@media screen and (min-width: 375px) and(max-width: 429px) and (orientation: portrait) {
  .module-layer1 {
    .kv-content {
      .kv-play-btn {
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer1.vue